(() => {
document.body.classList.remove('ff-noscript');

    const aSpecsDialog = document.getElementById('a-specifications');
    document.querySelector('[data-open-a-specs]')?.addEventListener('click', () => aSpecsDialog?.showModal());
    document.querySelector('[data-close-a-specs]')?.addEventListener('click', () => aSpecsDialog?.close());
    aSpecsDialog?.addEventListener('click', (event) => { if (event.target === aSpecsDialog) aSpecsDialog.close(); });

    document.querySelectorAll('[data-video-play]').forEach((playButton) => {
      const video = playButton.parentElement?.querySelector('[data-video]');
      playButton.addEventListener('click', async () => {
        if (video) video.controls = true;
        try { await video?.play(); } catch (_) { /* Native controls remain available if playback is blocked. */ }
      });
      video?.addEventListener('play', () => playButton.classList.add('is-playing'));
      video?.addEventListener('pause', () => playButton.classList.remove('is-playing'));
      video?.addEventListener('ended', () => {
        video.controls = false;
        playButton.classList.remove('is-playing');
      });
    });

    const facePanels = document.querySelectorAll('.ff-series-panel');
    facePanels.forEach((panel) => {
      const faceButtons = panel.querySelectorAll('.face-option');
      const selectedFace = panel.querySelector('.ff-face-stage__main img');
      if (!selectedFace) return;
      faceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        faceButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        selectedFace.classList.add('is-changing');
        selectedFace.src = button.dataset.face;
        selectedFace.alt = `${button.dataset.faceLabel || button.textContent.trim()} selected`;
      });
      });
      selectedFace.addEventListener('load', () => selectedFace.classList.remove('is-changing'));
    });

    const seriesTabs = [...document.querySelectorAll('.ff-series-tab')];
    const activateSeries = (tab, moveFocus = false) => {
      const nextPanel = document.getElementById(tab.dataset.seriesTarget);
      if (!nextPanel) return;
      seriesTabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        document.getElementById(item.dataset.seriesTarget).hidden = !selected;
      });
      if (moveFocus) tab.focus();
    };
    seriesTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateSeries(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = seriesTabs.length - 1;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + seriesTabs.length) % seriesTabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % seriesTabs.length;
        activateSeries(seriesTabs[nextIndex], true);
      });
    });

    const armorButtons = document.querySelectorAll('.armor-option');
    const selectedArmor = document.getElementById('selected-armor');
    armorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        armorButtons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        selectedArmor.classList.add('is-changing');
        selectedArmor.src = button.dataset.armor;
        selectedArmor.alt = `${button.textContent.trim()} selected`;
      });
    });
    selectedArmor.addEventListener('load', () => selectedArmor.classList.remove('is-changing'));

    const caseTabs = [...document.querySelectorAll('.ff-case-tab')];
    const casePanels = [...document.querySelectorAll('.ff-case-stage__media')];
    const caseReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const activateCaseLayer = (index, moveFocus = false) => {
      const nextTab = caseTabs[index];
      const nextPanel = casePanels[index];
      if (!nextTab || !nextPanel || nextTab.getAttribute('aria-selected') === 'true') return;

      caseTabs.forEach((tab) => tab.setAttribute('aria-selected', 'false'));
      casePanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });
      nextTab.setAttribute('aria-selected', 'true');
      nextPanel.classList.add('is-active');
      nextPanel.setAttribute('aria-hidden', 'false');
      if (moveFocus) nextTab.focus();

      if (!caseReduceMotion && window.gsap) {
        gsap.killTweensOf(nextPanel);
        gsap.fromTo(nextPanel, { autoAlpha: 0, scale: .985 }, {
          autoAlpha: 1,
          scale: 1,
          duration: .48,
          ease: 'power3.out',
          clearProps: 'transform,opacity,visibility'
        });
      }
    };

    caseTabs.forEach((tab, index) => {
      tab.addEventListener('mouseenter', () => activateCaseLayer(index));
      tab.addEventListener('focus', () => activateCaseLayer(index));
      tab.addEventListener('click', () => activateCaseLayer(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = caseTabs.length - 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + caseTabs.length) % caseTabs.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % caseTabs.length;
        activateCaseLayer(nextIndex, true);
      });
    });

    const consoleShots = document.querySelectorAll('.ff-console-shot');
    consoleShots.forEach((button) => {
      button.addEventListener('click', () => {
        const wasSelected = button.getAttribute('aria-pressed') === 'true';
        consoleShots.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', wasSelected ? 'false' : 'true');
      });
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion && window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.utils.toArray('.ff-reveal').forEach((element) => {
        gsap.fromTo(element, {
          y: 22
        }, {
          y: 0,
          duration: .8,
          ease: 'power3.out',
          scrollTrigger: { trigger: element, start: 'top 86%', once: true }
        });
      });

      const consoleMotion = gsap.matchMedia();
      consoleMotion.add('(min-width: 981px)', () => {
        const compactIn = [
          { x: -180, y: -88 }, { x: -60, y: -88 }, { x: 60, y: -88 }, { x: 180, y: -88 },
          { x: -180, y: 104 }, { x: -60, y: 104 }, { x: 60, y: 104 }, { x: 180, y: 104 }
        ];
        const spreadPositions = [
          { x: -20, y: -335, r: 0, z: 12 },
          { x: -335, y: -220, r: 0, z: 15 },
          { x: 315, y: -240, r: .65, z: 13 },
          { x: -360, y: 20, r: .55, z: 22 },
          { x: 355, y: 0, r: -.55, z: 14 },
          { x: -290, y: 275, r: -.45, z: 17 },
          { x: 330, y: 260, r: .5, z: 18 },
          { x: 90, y: 345, r: .15, z: 19 }
        ];
        const compactOut = [
          { x: -190, y: -82 }, { x: -64, y: -82 }, { x: 64, y: -82 }, { x: 190, y: -82 },
          { x: -190, y: 112 }, { x: -64, y: 112 }, { x: 64, y: 112 }, { x: 190, y: 112 }
        ];

        const consoleTimeline = gsap.timeline({
          defaults: { ease: 'none' },
          scrollTrigger: {
            id: 'ff-console-choreography',
            trigger: '.ff-console-stage',
            start: 'top 82%',
            end: 'bottom 18%',
            scrub: .65,
            invalidateOnRefresh: true
          }
        });

        consoleTimeline
          .addLabel('compact')
          .fromTo(consoleShots,
            {
              '--shot-x': (index) => `${compactIn[index].x}px`,
              '--shot-y': (index) => `${compactIn[index].y}px`,
              '--shot-r': '0deg',
              '--shot-scale': .54,
              autoAlpha: .55
            },
            {
              '--shot-x': (index) => `${spreadPositions[index].x}px`,
              '--shot-y': (index) => `${spreadPositions[index].y}px`,
              '--shot-r': (index) => `${spreadPositions[index].r}deg`,
              '--shot-scale': 1,
              zIndex: (index) => spreadPositions[index].z,
              autoAlpha: 1,
              duration: 1.05,
              stagger: .025,
              immediateRender: true
            }
          )
          .addLabel('spread')
          .to({}, { duration: 1.6 })
          .to(consoleShots, {
            '--shot-x': (index) => `${compactOut[index].x}px`,
            '--shot-y': (index) => `${compactOut[index].y}px`,
            '--shot-r': '0deg',
            '--shot-scale': .54,
            autoAlpha: .6,
            duration: 1.05,
            stagger: .025
          })
          .addLabel('recompact');

        return () => {
          consoleTimeline.scrollTrigger?.kill();
          consoleTimeline.kill();
        };
      });

      gsap.fromTo('[data-mechanism-visual]',
        { y: 90, rotate: -2 },
        {
          y: -35,
          rotate: 2,
          ease: 'none',
          scrollTrigger: {
            trigger: '.ff-mechanism__stage',
            start: 'top 78%',
            end: 'bottom 24%',
            scrub: .8
          }
        }
      );

      window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    } else {
      document.querySelectorAll('.ff-reveal').forEach((element) => {
        element.style.opacity = '1';
        element.style.transform = 'none';
      });
    }
})();
